var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocs = function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "docs_svg2__a",
    x1: 30.13,
    x2: 180.9,
    y1: 171.8,
    y2: 32.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#docs_svg2__a",
    id: "docs_svg2__b",
    x1: 16.45,
    x2: 167.23,
    y1: 156.96,
    y2: 18.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#docs_svg2__a",
    id: "docs_svg2__c",
    x1: 26.83,
    x2: 177.6,
    y1: 168.22,
    y2: 29.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#docs_svg2__a",
    id: "docs_svg2__d",
    x1: 37.2,
    x2: 187.98,
    y1: 179.48,
    y2: 40.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#docs_svg2__a",
    id: "docs_svg2__e",
    x1: 47.57,
    x2: 198.35,
    y1: 190.73,
    y2: 51.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#docs_svg2__a",
    id: "docs_svg2__f",
    x1: 57.94,
    x2: 208.72,
    y1: 201.99,
    y2: 63.07
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M198.35 25.24c-.12-.11-.26-.24-.42-.4l-.02-.02-22.82-21.76-.35-.33c-.9-.86-1.83-1.75-3.56-1.75H76.6c-2.76 0-5.01 2.25-5.01 5.01v15.38l-33.33 5.71c-2.67.47-4.47 3.03-4.01 5.69l1.69 9.86C25.12 46.27 14 50.03 3.24 53.89c-2.54.93-3.87 3.75-2.96 6.3l21.36 59.38a2.93 2.93 0 0 0 2.76 1.94c.33 0 .66-.06.99-.17a2.944 2.944 0 0 0 1.77-3.75L6.11 59.1c10.13-3.63 20.6-7.17 30.83-10.61l10.07 58.69 11.58 67.59c.42 2.39 2.52 4.08 4.88 4.08.27 0 .54-.02.81-.07l31.37-5.38 24.51-4.2-36.87 13.25-29.08 10.45-22.58-62.81a2.944 2.944 0 0 0-3.75-1.77 2.944 2.944 0 0 0-1.77 3.75l22.9 63.7a4.87 4.87 0 0 0 2.54 2.77c.67.32 1.38.47 2.1.47.56 0 1.13-.1 1.67-.3l29.95-10.77 68-24.44 12.99-2.23h28.7c2.76 0 5.01-2.25 5.01-5.02V28.54c0-1.75-.95-2.65-1.65-3.3Zm-7.76.7h-15.02c-.7 0-2.35.02-2.76-.4-.1-.1-.21-.42-.21-1.01l-.03-15.79 18.03 17.19ZM77.45 155.43v-57.1c0-1.62-1.31-2.93-2.93-2.93s-2.93 1.31-2.93 2.93v57.94c0 2.77 2.25 5.02 5.01 5.02h55l-36.93 6.33-30.46 5.23-11.42-66.67-12.6-73.49 31.41-5.38v57.43c0 1.62 1.31 2.93 2.93 2.93s2.93-1.31 2.93-2.93V6.83h89.25l.04 17.71c0 2.15.65 3.88 1.94 5.16 1.98 1.96 4.77 2.1 6.51 2.1h18.95v123.64H77.46Z",
    style: {
      fill: "url(#docs_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27 43.53H94.51c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h83.76c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#docs_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27 64.35H94.51c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h83.76c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#docs_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27 85.16H94.51c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h83.76c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#docs_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27 105.97H94.51c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h83.76c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#docs_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27 126.79H94.51c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h83.76c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#docs_svg2__f)"
    }
  }));
};
export default SvgDocs;